import translations from '../../translations.json';
import { Languages } from '../../models/translations';

const defaultLanguage: Languages = Languages.EN;

const supportedLanguages = [
   
    {
        name: 'Czech',
        tag: Languages.CS,
    },
    {
        name: 'Danish',
        tag: Languages.DA,
    },
    {
        name: 'Dutch',
        tag: Languages.NL,
    },
    {
        name: 'English (UK)',
        tag: Languages.GB,
    },
    {
        name: 'English (US)',
        tag: Languages.EN,
    },
    {
        name: 'Español MX',
        tag: Languages.MX,
    },
    {
        name: 'Español ES',
        tag: Languages.ES,
    },
    {
        name: 'French',
        tag: Languages.FR,
    },
    {
        name: 'German',
        tag: Languages.DE,
    },
    {
        name: 'Greek',
        tag: Languages.EL,
    },
    {
        name: 'Italian',
        tag: Languages.IT,
    },
    {
        name: '日本語',
        tag: Languages.JA,
    },
    {
        name: '简体中文',
        tag: Languages.ZH,
    },
    {
        name: '繁體中文',
        tag: Languages.TW,
    },
    {
        name: '한국어',
        tag: Languages.KO,
    },
    {
        name: 'Polish',
        tag: Languages.PL,
    },
    {
        name: 'Portuguese',
        tag: Languages.PT,
    },
    {
        name: 'Swedish',
        tag: Languages.SV,
    }
];

export { supportedLanguages, defaultLanguage, translations };
